import axios from 'axios';
import {
  RequestQueryBuilder,
  CreateQueryParams,
  CondOperator,
} from '@dataui/crud-request';

import {
  PRODUCT_DEFINITIONS_FETCH,
  PRODUCTS_SELECTED_ITEM_DELETE,
  PRODUCTS_SELECTED_JOB_ITEMS_ADD,
  PRODUCTS_SELECTED_SET,
  PRODUCTS_SELECTED_UNSET,
  PRODUCT_OPPORTUNITIES_FETCH,
  PRODUCT_PRESELECT_AUTOMATION,
  PRODUCT_SUPPLIERS_FETCH,
} from './types';
import {
  SERVICE_SELECTED_REFRESH,
  SERVICE_SELECTED_ITEM_DELETE,
} from '../services.module/types';

export default {
  [PRODUCTS_SELECTED_SET]: ({ commit, getters }, payload) => {
    commit(PRODUCTS_SELECTED_SET, payload);
  },
  [PRODUCTS_SELECTED_JOB_ITEMS_ADD]: ({ commit }, payload) => {
    let productElement = -1;
    if (payload.products.length > 0) {
      const jobProducts = payload.products.map((product) => {
        productElement++;
        return {
          id: product.id,
          elementIndex: productElement,
          jobId: payload.jobId,
          oemId: product.oem_id,
          product: product.id,
          quantity: product.quantity,
          supplier: product.supplier,
          supplier_sfid: product.supplier_sfid,
          supplier_name: product.supplier_name,
          serial_number: product.serial_number,
          chargepoint_number: product.chargepoint_number,
          invoicing_target: product.invoicing_target,
          price_purchasing: product.price_purchasing_net,
          price_selling: product.price_selling_net,
          price_listing: product.price_listing,
          selections: product.selections,
          product_id: product.product_id,
        };
      });
      commit(PRODUCTS_SELECTED_JOB_ITEMS_ADD, {
        [payload.jobId]: jobProducts,
      });
    }
  },
  [PRODUCTS_SELECTED_ITEM_DELETE]: ({ commit, dispatch }, payload) => {
    if (payload.sourceComponent) {
      if (payload.sourceComponent.length > 0) {
        // check if there is a need to delete associated service items:
        dispatch(SERVICE_SELECTED_ITEM_DELETE, payload);
      }
    }
    commit(PRODUCTS_SELECTED_ITEM_DELETE, payload);
  },
  [PRODUCT_SUPPLIERS_FETCH]: async ({ commit }) => {
    return axios.get(`/data-api/entity/brand`).then((response) => {
      commit(PRODUCT_SUPPLIERS_FETCH, { suppliers: response.data });
    });
  },
  [PRODUCT_DEFINITIONS_FETCH]: ({ commit, dispatch, state }, payload) => {
    if (payload.brand_id) {
      const query: CreateQueryParams = {
        filter: [
          {
            field: 'opportunities.opportunity',
            operator: CondOperator.EQUALS,
            value: payload.opportunity,
          },
        ],
        join: [
          { field: 'opportunities' },
          { field: 'services' },
          { field: 'services.service' },
        ],
      };
      const queryString = RequestQueryBuilder.create(query).query();

      return axios
        .get(`/data-api/product?${queryString}`)
        .then(async (response) => {
          if (response.data.length > 0) {
            const productData = await Promise.all(
              response.data.map(async (product) => {
                return {
                  ...product,
                };
              }),
            );
            commit(PRODUCT_DEFINITIONS_FETCH, {
              data: productData,
              opportunity: payload.opportunity,
            });
            if (state.selected?.[payload.jobId]?.length) {
              state.selected[payload.jobId].forEach((product) =>
                dispatch(PRODUCT_OPPORTUNITIES_FETCH, product.product),
              );
            }
          }
        });
    }
  },
  [PRODUCTS_SELECTED_UNSET]: ({ commit, dispatch, getters }, payload) => {
    const allSelectedProducts = getters.allSelectedProducts(payload.jobId);
    allSelectedProducts.map((product) => {
      const sourceComponent = `product-${product.product}-${product.elementIndex}`;
      dispatch(SERVICE_SELECTED_REFRESH, {
        jobId: payload.jobId,
        sourceComponent: sourceComponent,
      });
    });
    commit(PRODUCTS_SELECTED_UNSET, payload);
  },
  [PRODUCT_PRESELECT_AUTOMATION]: ({ commit, getters }, payload) => {
    return commit(PRODUCT_PRESELECT_AUTOMATION, payload);
  },
  [PRODUCT_OPPORTUNITIES_FETCH]: async ({ commit, state }, payload) => {
    const query: CreateQueryParams = {
      filter: [
        {
          field: 'product.id',
          operator: CondOperator.EQUALS,
          value: payload,
        },
        {
          field: 'opportunity.id',
          operator: CondOperator.EQUALS,
          value: state.definitions[payload]?.opportunity,
        },
      ],
      join: { field: 'product' },
    };
    const qb = RequestQueryBuilder.create(query).query();
    const { data } = await axios.get(`/data-api/product-opportunity/?${qb}`);
    const suppliers = data.map((entry) => ({
      ...entry.supplier,
      defaultSupplierType: entry.defaultProductSupplier,
      pricePurchasing:
        entry.pricePurchasing === undefined
          ? entry.product.price_purchasing_net
          : entry.pricePurchasing,
      priceSelling:
        entry.priceSelling === undefined
          ? entry.product.price_selling_net
          : entry.priceSelling,
      priceListing:
        entry.priceListing === undefined
          ? entry.product.price_listing
          : entry.priceListing,
    }));
    commit(PRODUCT_OPPORTUNITIES_FETCH, { suppliers, productId: payload });
  },
};
